<template>
  <div id="service">
    <div class="secondnav">
      <div id="secNavBox">
        <secondnav :nav="'about'"></secondnav>
      </div>
      <div id="secNavNextBox"></div>
    </div>
    <div class="views">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
  import secondnav from '../components/secondnav'
  export default {
    name: 'service',
    metaInfo: {
      title: '关于我们_速得尔科技（北京）有限公司', // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: '企业介绍，企业荣誉，战略客户，联系我们，速得尔'
      }, {                 // set meta
        name: 'description',
        content: '速得尔以创新技术服务中国射击事业，我们永不止步！'
      }]
    },
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    components:{secondnav},
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #service{
    background-color:#F6F5F4;
  }

</style>




// WEBPACK FOOTER //
// src/page/about.vue